import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerCountryAll: [],
  insurerCountry: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerCountrySlice = createSlice({
  name: "insurerCountry",
  initialState,
  reducers: {
    setInsurerCountryAll: (state, action) => {
      state.insurerCountryAll = action.payload;
    },
    setInsurerCountry: (state, action) => {
      state.insurerCountry = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerCountryAll,
  setInsurerCountry,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerCountrySlice.actions;

export default insurerCountrySlice.reducer;
